import type { CSSProperties } from 'react';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const LoadingBar: FunctionComponent<Props> = ({ className = '', progress, testId = TEST_ID }) => {
    const isIndeterminate = progress === undefined;
    const barStyle: CSSProperties | undefined = isIndeterminate
        ? undefined
        : { width: `${progress}%` };
    const barClass = `${styles.bar}${isIndeterminate ? ` ${styles.indeterminate}` : ''}`;

    return (
        <div
            aria-valuemax={isIndeterminate ? undefined : 100}
            aria-valuemin={isIndeterminate ? undefined : 0}
            aria-valuenow={isIndeterminate ? undefined : progress}
            className={`${styles.loadingBar}${className ? ` ${className}` : ''}`}
            data-testid={testId}
            role="progressbar"
        >
            <div className={barClass} style={barStyle} />
        </div>
    );
};

export default LoadingBar;
